import React, { useState, FC } from 'react';
import Fade from 'react-reveal/Fade';
import { TMosaicGalleryProps } from './types/mosaicGallery.types';
import MediaMosaicItem from './components/mediaMosaicItem';
import ModalDialog from '../modalDialog';
import MosaicModal from './components/mosaicModal';
import { TGalleryItem } from '../../../types/media.types';
import './styles.scss';
import { googleMediaClickEvent } from '../../../utils/analytics';
import useSitecoreContext from '../../../hooks/useSitecoreContext';

const MosaicGallery: FC<TMosaicGalleryProps> = ({ items, isEE, isAnalytics, galleryCardClickEvent }) => {
  const [itemToShow, setItemToShow] = useState<TGalleryItem | null>(null);
  const [selectedItemIndex, setSelectedItemIndex] = useState<number>(0);
  const [showModal, setShowModal] = useState<boolean>(false);
  const {sitecoreContext} = useSitecoreContext();
  const productLine = sitecoreContext?.analytics?.['productLine'] ? sitecoreContext?.analytics?.['productLine'] : undefined;
  const productSeries = sitecoreContext?.analytics?.['productSeries'] ? sitecoreContext?.analytics?.['productSeries'] : undefined;

  const handleItemClick = (item: TGalleryItem, index: number): void => {
    setSelectedItemIndex(index);
    setItemToShow(item);
    setShowModal(true);
  };

  const handleCloseModal = (): void => {
    setItemToShow(null);
    setShowModal(false);
  };

  const handleClickOnArrow = (index: number): void => {
    setSelectedItemIndex(index);
    setItemToShow(items[index]);
    setShowModal(true);
  };

  return (
    <>
      <div className={`mosaic mosaic--${items.length}`}>
        {items?.map((item: TGalleryItem, index: number) => (
          <Fade bottom>
            <div
              className={'mosaic__item'}
              key={item.title?.value}
              onClick={(): void => {
                handleItemClick(item, index);
                isAnalytics && googleMediaClickEvent(galleryCardClickEvent, item?.title?.value, 'image', productLine, productSeries);
              }}
            >
              <MediaMosaicItem media={item} isEE={isEE} />
            </div>
          </Fade>
        ))}
      </div>
      {itemToShow && (
        <ModalDialog isOpen={!!(!isEE && showModal)} close={handleCloseModal}>
          <MosaicModal
            selectedItem={itemToShow}
            items={items}
            selectedItemIndex={selectedItemIndex}
            handleMosaicItemChange={handleItemClick}
            showOverlayTitleAndDescription={true}
            handleClickOnArrow={handleClickOnArrow}
            isEE={isEE}
          />
        </ModalDialog>
      )}
    </>
  );
};

export default MosaicGallery;
